import { render, staticRenderFns } from "./SwitchButtons.vue?vue&type=template&id=4b3d8f28&scoped=true"
import script from "./SwitchButtons.vue?vue&type=script&lang=js"
export * from "./SwitchButtons.vue?vue&type=script&lang=js"
import style0 from "./SwitchButtons.vue?vue&type=style&index=0&id=4b3d8f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3d8f28",
  null
  
)

export default component.exports